// extracted by mini-css-extract-plugin
export default {"button_menu":"MenuCourse_button_menu__yBgri","menu_icon":"MenuCourse_menu_icon__dTUgF","menu_items":"MenuCourse_menu_items__YPm7N"};